@let localControl = control();
<mat-form-field
  [class]="'form-field ' + getFormFieldClass()"
  class="editable-field"
>
  @if (!disabled()){
  <input
    matInput
    #inputElement
    name="customInput"
    autocomplete="off"
    [formControl]="localControl!"
    [placeholder]="placeholder()"
    [required]="isRequired()"
    [disabled]="disabled()"
    [value]="fixedValue()"
    (blur)="onTouched()"
    (keydown.enter)="finishEditing(inputElement.value)"
    (keydown.escape)="handleEscape()"
  />
  } @else {
  <input
    matInput
    #inputElement
    name="customInput"
    autocomplete="off"
    [placeholder]="placeholder()"
    [required]="isRequired()"
    [disabled]="disabled()"
    [value]="fixedValue()"
  />}
</mat-form-field>
